// client/legend-cms/src/predictionTeams/index.js
import PredictionTeamList from './PredictionTeamList';
import PredictionTeamCreate from './PredictionTeamCreate';
import PredictionTeamEdit from './PredictionTeamEdit';
import EmojiFlagsIcon from '@material-ui/icons/EmojiFlags';

const predictionTeamsResource = {
  list: PredictionTeamList,
  create: PredictionTeamCreate,
  edit: PredictionTeamEdit,
  icon: EmojiFlagsIcon,
};

export default predictionTeamsResource;
